
class SpinnerView
{
  // ---------------------------------------------------------------------------------------------------------
	// --	SpinnerView
	// ---------------------------------------------------------------------------------------------------------

  constructor(){}

  /**
   * 表示
   */
  show()
  {
    //スピナー初期化
    if(!this.spinner)
    {
      //スピナー配置
      const opts = {
        lines: 13, // The number of lines to draw
        length: 8, // The length of each line
        width: 4, // The line thickness
        radius: 10, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#999', // #rgb or #rrggbb or array of colors
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: '50%', // Top position relative to parent
        left: '50%' // Left position relative to parent
      };
      this.spinner = new Spinner(opts);
      this.spinnerContainer = document.getElementById('spinner-container');
    }
    
    //回転
    $("#spinner-container").show();
		this.spinner.spin(this.spinnerContainer);
  }


  /**
   * 隠す
   */
  hide()
  {
    $("#spinner-container").hide();
    this.spinner.stop();
  }

	// ---------------------------------------------------------------------------------------------------------
}

export default new SpinnerView()